import React from "react";
import Helmet from "react-helmet";

import Title from "../components/Title";
import Item from "../components/Item";

export default () => (
  <>
    <Helmet>
      <Item>Data Policy | Heungdo Lab</Item>
    </Helmet>
    <div>
      <Title>Data Policy</Title>
      <Item>
        Please contact 'softwind.service@gmail.com' if you want to delete your datas
      </Item>
      <Item>We'll delete your datas within 3-5 days</Item>
    </div>
  </>
);
